import React from 'react';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Hidden,
  PropTypes,
  Theme,
} from '@mui/material';
import { WithStyles, WithTheme } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import withTheme from '@mui/styles/withTheme';
import ExpandMore from '@mui/icons-material/ExpandMore';

const styles = () => {
  return createStyles({
    bottomBox: {
      minHeight: '220px',
    },
  });
};

interface Props extends WithStyles<typeof styles>, WithTheme<Theme> {
  children : React.ReactChild;
  color    : PropTypes.Color;
  title    : string;
}

class PaymentMobileWrapperComponent extends React.Component<Props, any> {

  render() {
    const { color, theme, children, title } = this.props;
    return (
      <Hidden mdUp>
        <Accordion elevation={2} square={true} classes={{ root: 'tileBoxExpansion' }}>
          <AccordionSummary
            classes={{
              root       : 'condensed',
              content    : 'alignCenter removeMargin',
              expandIconWrapper : 'condensedIcon',
            }}
            expandIcon={<ExpandMore color={"primary"} />}
            style={{
              border       : `1px solid ${theme.palette[color].main}`,
              borderRadius : '4px',
            }}
          >
            <Typography
              align   = 'center'
              variant = 'body1'
              color   = "primary"
              classes = {{ body1: 'condensedAlign' }}
            >
              { title }
            </Typography>
          </AccordionSummary>
          <AccordionDetails classes={{ root: 'condensedDetails' }}>
            { children }
          </AccordionDetails>
        </Accordion>
      </Hidden>
    );
  }
}

export const PaymentMobileWrapper = withTheme(withStyles(styles)(PaymentMobileWrapperComponent));
